/* tslint:disable */
/* eslint-disable */
/**
 * 3DSurvey API
 * Frontend API for 3d Survey
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SurveyUploadData } from './SurveyUploadData';
import {
    SurveyUploadDataFromJSON,
    SurveyUploadDataFromJSONTyped,
    SurveyUploadDataToJSON,
} from './SurveyUploadData';

/**
 * 
 * @export
 * @interface CreateSurveyUpload200Response
 */
export interface CreateSurveyUpload200Response {
    /**
     * 
     * @type {boolean}
     * @memberof CreateSurveyUpload200Response
     */
    success: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateSurveyUpload200Response
     */
    error: string;
    /**
     * 
     * @type {SurveyUploadData}
     * @memberof CreateSurveyUpload200Response
     */
    data: SurveyUploadData;
}

/**
 * Check if a given object implements the CreateSurveyUpload200Response interface.
 */
export function instanceOfCreateSurveyUpload200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "success" in value;
    isInstance = isInstance && "error" in value;
    isInstance = isInstance && "data" in value;

    return isInstance;
}

export function CreateSurveyUpload200ResponseFromJSON(json: any): CreateSurveyUpload200Response {
    return CreateSurveyUpload200ResponseFromJSONTyped(json, false);
}

export function CreateSurveyUpload200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateSurveyUpload200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'success': json['success'],
        'error': json['error'],
        'data': SurveyUploadDataFromJSON(json['data']),
    };
}

export function CreateSurveyUpload200ResponseToJSON(value?: CreateSurveyUpload200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'success': value.success,
        'error': value.error,
        'data': SurveyUploadDataToJSON(value.data),
    };
}

